import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    legendsBox: {
      position: 'absolute',
      bottom: '25px',
      transform: 'translateX(10px)',
      zIndex: 1000,
      pointerEvents: 'auto',
      backgroundColor: '#131F00',
      padding: '8px 16px',
      borderRadius: 5,
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
    },
    legendsBoxTitle: {
      color: '#FFFFFF',
      fontFamily: 'Source Sans Pro',
      fontWeight: 600,
      fontSize: '12px',
    },
    legendsBoxItem: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      '& .MuiTypography-root': {
        color: '#FFFFFF',
        fontFamily: 'Source Sans Pro',
        fontWeight: 600,
        fontSize: '11px',
      },
    },
    styleIdentifier: {
      width: '16px',
      height: '16px',
    },
  }),
)
